import React from 'react'
import cn from 'classnames'
import { Grid } from 'styled-css-grid'
import useStores from '@stores/useStores'
import useCustomization from '@hooks/useCustomization'
import Loader from '@ui/Loader'
import Main from './Main'
import TopNav from './TopNav'
import BottomNav from './BottomNav'
import './styles.scss'

const Layout = props => {
  const { surveyState, appState } = useStores()
  useCustomization()

  const { className = '', all, retrieving } = props
  const textDirection = appState.getTextDirection(surveyState.language_code)

  return retrieving ? (
    <Loader />
  ) : (
    <Grid
      dir={textDirection}
      columns='370px 1fr'
      areas={['topNav main', 'bottomNav main']}
      columnGap='0'
      rowGap='0'
      className={cn(`survey-layout ${className}`, {
        all,
        branded: surveyState.hasBrandColor
      })}
    >
      {props.children}
    </Grid>
  )
}

Layout.Main = Main
Layout.TopNav = TopNav
Layout.BottomNav = BottomNav

export default Layout
